/* eslint-disable @typescript-eslint/no-explicit-any */
import { getModel } from '../../../services/api2.service';
import { IListSportReturn } from '../interfaces/club';

/**
 * Get all sports
 */
export const getAllSports = async (): Promise<IListSportReturn> => {
    const urlModel = `sports`;

    const data = await getModel(urlModel);
    return data;
};
